/**
 * Partner ledger UI constants — keep aligned with
 * functions/src/organizations/partnerLedger.js
 */

import { normalizePartnerTier } from "./partnerTiers";

export const MANUAL_ADJUSTMENT = "manual_adjustment";

/** Empty value means settlementRail: null on create. */
export const SETTLEMENT_RAIL_NONE = "";

export const SETTLEMENT_RAIL_OPTIONS = [
  { value: SETTLEMENT_RAIL_NONE, label: "None yet" },
  { value: "agent_manual_kenya", label: "Agent manual (Kenya)" },
  { value: "stripe_connect_us", label: "Stripe Connect (US)" },
];

/** Tiers a Founding Partner may attribute a ledger entry to (besides itself). */
export const ATTRIBUTED_LINKED_TIERS = new Set(["fusion", "fusion_affiliate"]);

export function settlementRailForCreate(value) {
  if (value == null || value === SETTLEMENT_RAIL_NONE) return null;
  return value;
}

/**
 * Client-side match of prompt 1's attribution check: own founding org or a
 * linked Fusion Partner / Fusion Affiliate. Not a replacement for the server.
 */
export function isAttributableLedgerOrg({
  orgId,
  partnerTier,
  foundingPartnerId,
  foundingPartnerOrgId,
}) {
  if (!orgId || !foundingPartnerOrgId) return false;
  const tier = normalizePartnerTier(partnerTier);
  if (orgId === foundingPartnerOrgId) {
    return tier === "founding";
  }
  return (
    foundingPartnerId === foundingPartnerOrgId &&
    ATTRIBUTED_LINKED_TIERS.has(tier)
  );
}

/**
 * Balances rows already come from the founding-partner hierarchy callable.
 * Still hide non-fusion/affiliate linked rows from the Record entry dropdown.
 */
export function isAttributableBalanceRow(row, foundingPartnerOrgId) {
  if (!row?.orgId || !foundingPartnerOrgId) return false;
  const tier = normalizePartnerTier(row.partnerTier);
  if (row.orgId === foundingPartnerOrgId) {
    return tier === "founding";
  }
  return ATTRIBUTED_LINKED_TIERS.has(tier);
}
